
import ScrollToTop from "@/components/ui/ScrollTop";
import MainLayout from "@/layout/MainLayout";
import { LoginRedirect } from "@/components/common/LoginRedirect";
import { SignupRedirect } from "@/components/common/SignupRedirect";
import Company from "@/pages/company/CompanyMainPage";
import { ContactPage } from "@/pages/contact/ContactPage";
import NotFoundPage from "@/pages/error/404";
import GetStarted from "@/pages/getStarted/GetStarted";
import Homepage from "@/pages/home/Home";
import VaWeNaLandingPage from "@/pages/platform/PlatformMain";
import PricingPage from "@/pages/pricing/PricingPage";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfService from "@/pages/legal/TermsOfService";
import WealthScopePage from "@/pages/wealthscope/WealthScopePage";
import PortfolioIQPage from "@/pages/portfolioiq/PortfolioIQPage";
import BundlePage from "@/pages/bundle/BundlePage";
import InvestmentReadinessQuiz from "@/pages/quiz/InvestmentReadinessQuiz";
import ErrorBoundary from "@/utils/ErrorBoundry";
import { Routes, Route } from "react-router-dom";

// Later we can add ProtectedRoute, RoleBasedRoute etc.
function AppRoutes() {
    return (

        <ErrorBoundary>
             <ScrollToTop/>
            <MainLayout>

                <div className="items-center">
                <Routes  >
                    <Route path="/" element={<Homepage />} />
                    <Route path="/platform" element={<VaWeNaLandingPage />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/company" element={<Company />} />
                    <Route path="/login" element={<LoginRedirect />} />
                    <Route path="/signup" element={<SignupRedirect />} />
                    <Route path="/get-started" element={<GetStarted />} />
                    <Route path="/wealthscope" element={<WealthScopePage />} />
                    <Route path="/portfolioiq" element={<PortfolioIQPage />} />
                    <Route path="/bundle" element={<BundlePage />} />
                    <Route path="/quiz" element={<InvestmentReadinessQuiz />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="*" element={<NotFoundPage />} />

                </Routes>
                </div>
            </MainLayout>
        </ErrorBoundary>


    );
}

export default AppRoutes;
